import { render, staticRenderFns } from "./AssinaturaBox.vue?vue&type=template&id=e53f9ddc&lang=pug"
import script from "./AssinaturaBox.vue?vue&type=script&lang=js"
export * from "./AssinaturaBox.vue?vue&type=script&lang=js"
import style0 from "./AssinaturaBox.vue?vue&type=style&index=0&id=e53f9ddc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports